/* views.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 16 16" preserveAspectRatio="none">            
                <path class="foreground-gl" d="M14.7,16H3.1c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h11.6c0.2,0,0.4-0.2,0.4-0.4V3.1c0-0.2,0.2-0.4,0.4-0.4
                    S16,2.9,16,3.1v11.6C16,15.4,15.4,16,14.7,16z"/>
                <path class="foreground-gl" d="M12,0H1.3C0.6,0,0,0.6,0,1.3V12c0,0.7,0.6,1.3,1.3,1.3H12c0.7,0,1.3-0.6,1.3-1.3V1.3C13.3,0.6,12.7,0,12,0z
                     M9.9,3l-2.7,7.5c-0.1,0.2-0.1,0.3-0.4,0.3H6.4c-0.2,0-0.3-0.1-0.3-0.3L3.4,3c-0.1-0.2,0-0.3,0.2-0.3h0.5c0.3,0,0.3,0.1,0.4,0.3
                    l2.2,6.4h0L8.8,3C8.9,2.7,9,2.6,9.2,2.6h0.5C9.9,2.6,10,2.7,9.9,3z"/>
            </svg>
         `
};
